define([
	"dojo/_base/declare",
	"dijit/focus",
	"dijit/form/ComboBox",
	"dijit/form/_TextBoxMixin",
	"./_ComboBoxMixin"
], function(declare,focus,ComboBox,_TextBoxMixin,_ComboBoxMixin) {

	return declare([ComboBox, _ComboBoxMixin], {
		// disable auto-completion on ComboBox when doing substring matching - otherwise can get extra
		// characters at beginning when you no longer match values - for example, if you type "ar" and
		// it auto-completes to "Garden", but then you type "t", you end up with searching for "Gart"
		// rather than just "art"
		autoComplete: false,

		onSelectOption: function() {
			// summary: extension point for selecting an option which does not necessarily mean a change in value;
			// this is more appropriate for inline editing than using just onChange
		},

		_onFocus: function(/*String*/by) {
			// summary: only open drop-down and select text when triggered by mouse and widget is still in focus (C8-3316)
			this.inherited(arguments);

			this.defer(function() {
				if (this.focusNode == focus.curNode) {
					if (by == 'mouse') {
						this.toggleDropDown();
					}

					_TextBoxMixin.selectInputText(this.focusNode);
				}
			});
		},

		_selectOption: function(/*DOMNode*/target) {
			// summary: call extension point when new option is selected - either by mouse click or Enter key
			this.inherited(arguments);

			if (target){
				this.onSelectOption();
			}
		}
	});
});